import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'stripTags',
	standalone: true,
})
export class StripTagsPipe implements PipeTransform {

	transform(value: string) {
		if (value) {
			const result = value.replace(/<\/?[^>]+>/gi, "")
							  .replace(/&nbsp;/g," ")
							  .replace(/&rsquo;/g, "'")
							  .replace(/&ndash;/g, "-")
							  .replace(/&pound;/g, "£")
							  .replace(/&euro;/g, "€")
							  .replace(/&hellip;/g, "...")
							  .replace(/&ldquo;/g, "")
							  .replace(/&oacute;/g, "ó")
							  .replace(/&#xa0;/g, " ")
							  .replace(/&amp;/g, "&");
			return result;
		}
	}

}
